import React from 'react';
import { Navigate } from 'react-router-dom';

/**
 * Legacy redirect: old separate /rewards/login and /rewards/signup pages
 * are now part of the unified /rewards hub. We deep-link via ?auth=login|signup
 * so external emails / saved bookmarks keep working.
 */
export const RewardsSignupRedirect = () => <Navigate to="/rewards?auth=signup" replace />;
export const RewardsLoginRedirect = () => <Navigate to="/rewards?auth=login" replace />;
